import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { FaUserEdit, FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import api from "../../services/axiosInstance"

const ProfilePage = () => {
  const { user, accessToken } = useAuth();
  const [profile, setProfile] = useState(null);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email:"",
    bio: "",
    wilaya: "",
    achievements: "",
    number: "",
  });

useEffect(() => {
  const fetchProfile = async () => {
    try {
      const res = await api.get(`/users/get-user-info/${user.id}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      const data = res.data;
      setProfile(data);
      setForm({
        name:data.name|| "",
        bio: data.bio || "",
        wilaya: data.wilaya || "",
        email: data.email || "",
        achievements: data.achievements || "",
        number: data.number || "",
      });
    } catch (err) {
      console.error("❌ Failed to fetch profile:", err);
    }
  };

  if (user?.id) fetchProfile();
}, [user, accessToken]);

const handleChange = (e) =>
  setForm({ ...form, [e.target.name]: e.target.value });

const handleSave = async () => { 
  try {
    const res = await api.put(`/users/update-user/${user.id}`, form, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    const data = res.data;
    setProfile(data.user);
    setEditing(false);
    alert("✅ Profil mis à jour avec succès !");
  } catch (err) {
    console.error("❌ Update error:", err);
    alert(
      err.response?.data?.message ||
        "Erreur lors de la mise à jour du profil."
    );
  }
};
  if (!profile) return <p className="text-center mt-10">Chargement...</p>;

  const isStudent = profile.role === "student";

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
  <div className="bg-white rounded-xl max-w-2xl w-full p-6 md:p-8 shadow-sm border border-gray-200">
    
    {/* Profile Header */}
    <div className="flex flex-col items-center text-center mb-8">
      <div className="relative mb-4">
        <div className="w-24 h-24 rounded-full bg-gradient-to-tr from-emerald-100 to-emerald-300 flex items-center justify-center text-gray-800 text-3xl font-medium">
          {profile.name?.[0] || "U"}
        </div>
        
        <button
          onClick={() => setEditing(true)}
          className="absolute bottom-0 right-0 bg-emerald-800 text-white p-2 rounded-full hover:bg-emerald-900 transition-colors"
        >
          <FaUserEdit size={16} />
        </button>
      </div>

      <h2 className="text-2xl font-semibold text-gray-900">{profile.name}</h2>
      <p className="text-gray-600 text-sm capitalize mt-1">{profile.role}</p>
    </div>

    {/* Info Section */}
    {!editing ? (
      <div className="space-y-4">
        <div className="flex items-center gap-3 p-3 border-b border-gray-100">
          <FaEnvelope className="text-gray-500" size={18} />
          <span className="text-gray-700">{profile.email}</span>
        </div>

        <div className="flex items-center gap-3 p-3 border-b border-gray-100">
          <FaPhone className="text-gray-500" size={18} />
          <span className="text-gray-700">{profile.number || "—"}</span>
        </div>

        <div className="flex items-center gap-3 p-3 border-b border-gray-100">
          <FaMapMarkerAlt className="text-gray-500" size={18} />
          <span className="text-gray-700">{profile.wilaya || "—"}</span>
        </div>

        {!isStudent && (
          <>
            <div className="mt-6 pt-4 border-t border-gray-100">
              <h3 className="font-medium text-gray-900 mb-3">Bio</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {profile.bio || "—"}
              </p>
            </div>

            <div className="pt-4">
              <h3 className="font-medium text-gray-900 mb-3">Réalisations</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {profile.achievements || "—"}
              </p>
            </div>
          </>
        )}
      </div>
    ) : (
      <div className="space-y-5">
        <div>
          <label className="block text-sm text-gray-700 mb-2 font-medium">
            Nom complet
          </label>
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-1 focus:ring-emerald-800 focus:border-emerald-800"
          />
        </div>

        <div>
          <label className="block text-sm text-gray-700 mb-2 font-medium">
            Wilaya
          </label>
          <input
            type="text"
            name="wilaya"
            value={form.wilaya}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-1 focus:ring-emerald-800 focus:border-emerald-800"
          />
        </div>

        <div>
          <label className="block text-sm text-gray-700 mb-2 font-medium">
            Email
          </label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-1 focus:ring-emerald-800 focus:border-emerald-800"
          />
        </div>

        <div>
          <label className="block text-sm text-gray-700 mb-2 font-medium">
            Numéro de téléphone
          </label>
          <input
            type="text"
            name="number"
            value={form.number}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-1 focus:ring-emerald-800 focus:border-emerald-800"
          />
        </div>

        {!isStudent && (
          <>
            <div>
              <label className="block text-sm text-gray-700 mb-2 font-medium">
                Bio
              </label>
              <textarea
                name="bio"
                value={form.bio}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-1 focus:ring-emerald-800 focus:border-emerald-800"
                rows="3"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-700 mb-2 font-medium">
                Réalisations
              </label>
              <textarea
                name="achievements"
                value={form.achievements}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-1 focus:ring-emerald-800 focus:border-emerald-800"
                rows="3"
              />
            </div>
          </>
        )}

        {/* Buttons */}
        <div className="flex justify-end gap-3 pt-4">
          <button
            onClick={() => setEditing(false)}
            className="px-5 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Annuler
          </button>
          <button
            onClick={handleSave}
            className="px-5 py-2.5 bg-emerald-800 text-white rounded-lg hover:bg-emerald-900 transition-colors"
          >
            Enregistrer
          </button>
        </div>
      </div>
    )}
  </div>
</div> 
 
  );
};
 
export default ProfilePage;